export function getCurrentURLWithoutHost() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
